import { render, staticRenderFns } from "./CreateBankKidsDialog.vue?vue&type=template&id=dd717732&scoped=true"
import script from "./CreateBankKidsDialog.vue?vue&type=script&lang=js"
export * from "./CreateBankKidsDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateBankKidsDialog.vue?vue&type=style&index=0&id=dd717732&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd717732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd717732')) {
      api.createRecord('dd717732', component.options)
    } else {
      api.reload('dd717732', component.options)
    }
    module.hot.accept("./CreateBankKidsDialog.vue?vue&type=template&id=dd717732&scoped=true", function () {
      api.rerender('dd717732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentDialog/CreateBankKidsDialog.vue"
export default component.exports